export default "__VITE_ASSET__51c7fa4b__"